import { createClient } from "@supabase/supabase-js";

const url = (process.env.REACT_APP_SUPABASE_URL || "").trim();
const key = (process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || "").trim();
function configured() {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && !parsed.username && !parsed.password && !parsed.search && !parsed.hash && parsed.pathname === "/" && key.startsWith("sb_publishable_");
  } catch { return false; }
}
export const supabase = configured() ? createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: "implicit" },
}) : null;
export const accountRedirect = () => `${window.location.origin}/compte`;
export function authMessage(error) {
  const messages = {
    invalid_credentials: "Adresse e-mail ou mot de passe incorrect.",
    email_not_confirmed: "Confirme ton adresse e-mail avant de te connecter.",
    over_email_send_rate_limit: "Trop de demandes. Patiente quelques minutes avant de réessayer.",
    over_request_rate_limit: "Trop de demandes. Patiente quelques minutes avant de réessayer.",
    email_address_not_authorized: "L’envoi des e-mails est encore limité aux tests. Contacte l’administrateur.",
    weak_password: "Choisis un mot de passe robuste d’au moins 8 caractères.",
    same_password: "Choisis un mot de passe différent de l’ancien.",
    signup_disabled: "Les inscriptions sont momentanément fermées.",
    otp_expired: "Ce lien a expiré. Demande un nouvel e-mail.",
  };
  return messages[error?.code] || (error?.status === 429 ? messages.over_request_rate_limit : "La demande n’a pas abouti. Vérifie ta connexion et réessaie.");
}
